import Api from "../../api.js";

export const deleteItem = async (url) => {
    return (await Api.delete(url))?.data
}
